import { makeStyles } from "@material-ui/core/styles";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import { useUserSettingsContext } from "contexts/UserSettingsProvider";
import React, { useEffect, useRef, useState } from "react";
import { isNullUndEmpty } from "utils/general";
import { TerminalToggleButtonGroup } from "./TerminalToggleButtonGroup";
import { filterColors } from "../../utils/constants";

const useStyles = makeStyles({
	filterTerminal: {
		backgroundColor: filterColors.terminal,
	},
});

export const TERMINAL_DEFAULT_VALUE = 1;

export const ToggleTerminalsFilter = ({ optionValue = "id", optionName = "name" }) => {
	const classes = useStyles();
	const { data: terminalsData = {} } = useTerminalsContext();
	const { data: userSettings } = useUserSettingsContext();
	const { data: globalFilters = {}, isLoading, updateData } = useGridUserDataGlobalFiltersContext();

	const [filterValue, setFilterValue] = useState([TERMINAL_DEFAULT_VALUE]);
	const hasInitialized = useRef(false);

	const terminals = Object.values(terminalsData);

	const operationalTerminalId = userSettings ? userSettings.operational_terminal_id : null;
	const disabled = operationalTerminalId != null;

	useEffect(() => {
		if (isLoading) return;

		if (disabled) {
			setFilterValue([operationalTerminalId]);
			hasInitialized.current = true;
			if (JSON.stringify(globalFilters?.terminal_id) !== JSON.stringify([operationalTerminalId])) {
				updateData({ terminal_id: [operationalTerminalId] });
			}
		} else if (!isNullUndEmpty(globalFilters?.terminal_id)) {
			setFilterValue(globalFilters.terminal_id);
			hasInitialized.current = true;
		} else if (!hasInitialized.current) {
			updateData({ terminal_id: [TERMINAL_DEFAULT_VALUE] });
			hasInitialized.current = true;
		}
	}, [isLoading, globalFilters, updateData, disabled, operationalTerminalId]);

	if (terminals.length === 0) return null;

	const handleChange = (_e, newValues) => {
		if (disabled) return;
		const newValue = [newValues];
		if (JSON.stringify(filterValue) !== JSON.stringify(newValue)) {
			updateData({ terminal_id: newValue });
		}
	};

	return (
		<React.Fragment>
			<TerminalToggleButtonGroup
				terminals={terminals}
				className={classes.filterTerminal}
				value={filterValue}
				onChange={handleChange}
				optionName={optionName}
				optionValue={optionValue}
				disabled={disabled}
				exclusive
			/>
		</React.Fragment>
	);
};
